import { useMemo } from "react";
import { useHistory, useLocation, useParams, useRouteMatch } from "react-router-dom";
import queryString from "querystring";

const useRouter = () => {
  const params = useParams();
  const location = useLocation();
  const history = useHistory();
  const match = useRouteMatch();

  return useMemo(() => {
    return {
      push: history.push,
      replace: history.replace,
      pathname: location.pathname,
      query: {
        ...queryString.parse(location.search.slice(1)),
        ...params,
      },
      match,
      location,
      history,
      // 👇 Simulated reload (soft reload of the current route)
      reload: () => {
        history.replace({
          pathname: location.pathname,
          search: location.search,
          state: { reload: Date.now() }, // trigger change
        });
      },
    };
  }, [params, match, location, history]);
};

export default useRouter;
